import { Box } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";

const TypingIndicator = () => (
  <Box display="flex" alignItems="center" pl={1} pr={1}>
    {[0, 1, 2].map((i) => (
      <motion.span
        key={i}
        initial={{ opacity: 0.3, y: 0 }}
        animate={{
          opacity: [0.3, 1, 0.3],
          y: [0, -5, 0],
        }}
        transition={{
          duration: 0.6,
          repeat: Infinity,
          delay: i * 0.2,
        }}
        style={{
          width: 6,
          height: 6,
          margin: "0 2px",
          borderRadius: "50%",
          backgroundColor: "#999",
          display: "inline-block",
        }}
      />
    ))}
  </Box>
);

export default TypingIndicator;
